module.exports = __webpack_public_path__ + "static/media/code2.549690d1.svg";